import { object, string } from "yup";
import i18next from "/app/src/locales/config";

export const userLoginSchema = object().shape({
  username: string().required(i18next.t("translation:username_is_required")),

  password: string().required(i18next.t("translation:password_is_required")),
});
